import {
  darken,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useState } from 'react';
import { themeColors } from 'src/theme/schemes/PureLightTheme';
import CloseIcon from '@mui/icons-material/Close';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import WAButton from '../WAButton';
// import ProductTourButton from '../ProductTourButton';
import { useAppSelector } from 'src/app/hooks';
import { FirstTimeTour } from 'src/constants/productTour/FirstTimeTour';
import ForumIcon from '@mui/icons-material/Forum';
import { useAppDispatch } from 'src/app/hooks';
// import { setPictureInPictureMode } from 'src/features/chatNow';
import VideoButton from '../VideoButton';
import { reducerUpdateOpenAIAssistant } from 'src/features/AIAssistantPosition';
import { toogleSidebar } from 'src/features/sidebarToggleSlice';

const FloatingButtons = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const [isExpanded, setIsExpanded] = useState(false);

  const {
    isOnTour,
    currentTour: { stepNumber, menu }
  } = useAppSelector((state) => state.storeProductTour);

  const isCurrentlyOnTourFirstTimeStep5 =
    isOnTour && stepNumber === 5 && menu === FirstTimeTour.menu;
  const isCurrentlyOnTourFirstTimeStep6 =
    isOnTour && stepNumber === 6 && menu === FirstTimeTour.menu;

  const isHideFloatingButton = () => {
    const isPerisai = window.location.hostname.includes('perisai');
    const isAntara = window.location.hostname.includes('antaranews');
    const isKpsg = window.location.hostname.includes('kpsg');
    const isTelkomsel =
      window.location.hostname.includes('tsight') ||
      window.location.hostname.includes('sentrix');
    const isCitiasia = window.location.hostname.includes('citiasiainc');

    return isPerisai || isAntara || isKpsg || isCitiasia || isTelkomsel;
  };

  const tooltipProps = {
    modifiers: [
      {
        name: 'preventOverflow',
        options: {
          boundary: 'viewport'
        }
      },
      {
        name: 'offset',
        options: {
          offset: [0, 0]
        }
      }
    ]
  };

  const sidebarToggle = useAppSelector((state) => state.sidebarToggle.toggle);
  const { isOpen: isAIAssistantOpen } = useAppSelector(
    (state) => state.storeAIAssistantPosition
  );

  const handleOpenAIAssistant = () => {
    dispatch(reducerUpdateOpenAIAssistant(!isAIAssistantOpen));
    dispatch(toogleSidebar(!sidebarToggle));
  };

  if (isHideFloatingButton()) return <></>;

  return (
    <>
      {matchesUpMd ? (
        <IconButton
          onClick={!isOnTour ? () => setIsExpanded((prev) => !prev) : undefined}
          sx={{
            position: 'fixed',
            zIndex: 1000,
            bottom: '10px',
            right: '20px',
            padding: '16px',
            width: '42px',
            height: '42px',
            borderRadius: '100%',
            cursor: 'pointer',
            backgroundColor: themeColors.darkTeal,
            color: '#fff',
            '&:hover': {
              backgroundColor: `${darken(themeColors.darkTeal, 0.3)}`
            }
          }}
        >
          {isCurrentlyOnTourFirstTimeStep5 ||
          isCurrentlyOnTourFirstTimeStep6 ||
          isExpanded ? (
            <CloseIcon />
          ) : (
            <PermPhoneMsgIcon />
          )}
        </IconButton>
      ) : null}
      {(isCurrentlyOnTourFirstTimeStep5 ||
        isCurrentlyOnTourFirstTimeStep6 ||
        isExpanded) && (
        <Tooltip
          arrow
          title="Customer support"
          placement="left"
          PopperProps={tooltipProps}
        >
          <WAButton />
        </Tooltip>
      )}
      {/* {(isCurrentlyOnTourFirstTimeStep5 ||
        isCurrentlyOnTourFirstTimeStep6 ||
        isExpanded) && (
        <Tooltip
          arrow
          title="Product tour"
          placement="left"
          PopperProps={tooltipProps}
        >
          <ProductTourButton />
        </Tooltip>
      )} */}
      {(isCurrentlyOnTourFirstTimeStep5 ||
        isCurrentlyOnTourFirstTimeStep6 ||
        isExpanded) && (
        <Tooltip
          arrow
          title="Video Tutorial"
          placement="left"
          PopperProps={tooltipProps}
        >
          <VideoButton />
        </Tooltip>
      )}
      {isExpanded && (
        <Tooltip
          arrow
          title="AI Assistant"
          placement="left"
          PopperProps={tooltipProps}
        >
          <IconButton
            sx={{
              width: '42px',
              height: '42px',
              position: 'fixed',
              zIndex: 999,
              bottom: '160px',
              right: '20px',
              padding: '16px',
              color: '#fff',
              background: 'linear-gradient(135deg, #43CBFF 0%, #9708CC 100%)'
            }}
            onClick={() => handleOpenAIAssistant()}
          >
            <ForumIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};

export default FloatingButtons;
